import { Component, OnInit } from '@angular/core';
import { SelectItem, MessageService } from 'primeng/api';
import { StatusService } from '@app/services/status.service';
import { QueryOptions } from '@app/model/query-options';
import { RecruiterService } from '@app/services/recruiterService';
import { JobCommentServiceGet } from '@app/services/jobCommentGet.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleInterviewService } from '@app/services/scheduleInterview.service';
import { JobService } from '@app/services/job.service';
import { ApplicantService } from '@app/services/applicant.service';
import { debug } from 'util';
import { ScheduleInterview } from '@app/model/scheduleInterview';
import { InterviewStepService } from '@app/services/interviewStep.service';
import { InterviewStep } from '@app/model/interviewStep';
import {Location} from '@angular/common';
import { ViewScheduledInterviewService } from '@app/services/viewScheduledInterview.service';
import {  Messages } from '@app/constants/constant';
import { ApplicantDataService } from '@app/services/applicantData.service';


@Component({
  selector: 'app-candidate-feedback',
  templateUrl: './candidate-feedback.component.html',
  styleUrls: ['./candidate-feedback.component.css']
})


export class CandidateFeedbackComponent implements OnInit {
  status: any;
  roles:any;
  records: any;
  record: any[];
  cols: any[];
  totalRecords: number;
  interviewId: any;
  applicantId : any;
  jobId :any;
  feedback :any={ 
    jobRole:'',
    technology:'',
    jobDescription:'',
    noOfPosition:'',
    createdOn:'',
    openJobCount:'',
    pendingJobCount:'',
    closedJobCount:'',
    name :'',
    mobile :''
  }
  
  constructor( private _apiStatus: StatusService,
    private _recruiterService: RecruiterService,
    private _jobCommentServiceGet: JobCommentServiceGet,
    private _jobService: JobService,
    private activatedRoute : ActivatedRoute,
    private _toastService : MessageService,
    private _scheduleInterviewService: ScheduleInterviewService,
    private __applicantService : ApplicantService,
    private _interviewStepService :InterviewStepService,
    private _viewScheduledInterviewService: ViewScheduledInterviewService,
    private _router : Router,
    private _location: Location
    ) {
    
   }
   ngOnDestroy() {
    // ...
  }
  ngOnInit() {
    localStorage.setItem("clearFilter","false");
    this.interviewId= this.activatedRoute.snapshot.params['id'];
      this._scheduleInterviewService.read(this.interviewId, 'interview').subscribe(
        res => {
          this.applicantId= res.applicantId ? res.applicantId : '';
          this.jobId= res.jobId ?res.jobId : '';
          this._jobService.read(this.jobId).subscribe(
            res => {
              this.feedback.jobRole=  res.jobCategory ? res.jobCategory.name : '';
              this.feedback.jobDescription= res.jobDescription ? res.jobDescription.name : '';
              this.feedback.technology= res.technology ? res.technology.name : '';
              this.feedback.noOfPosition=res.noOfVacancies ? res.noOfVacancies:'';
              this.feedback.openJobCount=res.openJobCount ? res.openJobCount: 0;
              this.roles= res.jobAssignedRecruiter? res.jobAssignedRecruiter.users : 'no assigned recruiters';
              this.feedback.closedJobCount=res.closedJobCount? res.closedJobCount : 0;
              this.feedback.pendingJobCount = res.pendingJobCount ?res.pendingJobCount : 0;
              this.__applicantService.read(this.applicantId).subscribe(app=>{
              this.feedback.name = app.fullName ? app.fullName :'';
              this.feedback.mobile= app.phone  ? app.phone :'';
              })          
        });

      });


    this.cols = [
      { field: 'startDate', header: 'Date & Time' ,},
      { field: 'interviewStep',  subfield: 'name', header: 'Interview Type' },
      { field: 'interviewMode',  subfield: 'name', header: 'Interview Mode' },
      { field: 'interviewer',subfield:'firstName', header: 'Interviewer' },
      { field: 'interviewStepStatus',subfield:'name', header: 'Status' },
      { field: 'notes', header: 'Recruiter Remark' }
      
  ];
  var params= this.queryParams("startTime",-1);
      var endpoint ='interview/post-interview-mapping/'+this.interviewId;
   this._viewScheduledInterviewService.list(params,endpoint).subscribe(res => {
      res.forEach(element => {
        if(element["submitted"]==0){
          element["interviewStepStatus"]["name"] = "Feedback saved as draft";
        }
        if(!element["interviewStepStatus"]){
          element["interviewStepStatus"] = element["interviewStatus"]
          element["interviewMode"] = {};
          element["interviewMode"]["name"] = "NA";
          element["interviewer"]=[{}];
          element["interviewer"][0]["firstName"] = "NA";
          element["interviewStep"]={};
          element["interviewStep"]["name"] = "NA";
        }
      });
      this.records = res;

  });
  }

  queryParams(sortField,sortOrder){
    const queryParams = new Object();
    queryParams['sortParam'] = { sortField: sortField, sortOrder: sortOrder };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
}
redirectToPreviousPage(){
  this._router.navigateByUrl('/interview-schedule-list', { skipLocationChange: true }).then(() => {
    this._router.navigate(['view-scheduled-interview-list/'+ this.jobId ]);
  });
}  

}
